module.exports = __webpack_public_path__ + "static/EnmTX_BosDeathTiger_L_C_cl-74e1d981d309c35baaad5e161d275b9c.gif";